import { createSelector } from 'reselect';

const commonSelector = (state: any) => state.common;

export const transportDataSelector = createSelector(commonSelector, (common) => common.transportData);

export const dischargeDataSelector = createSelector(commonSelector, (common) => common.dischargeTypeData);

export const termDataSelector = createSelector(commonSelector, (common) => common.termData);

export const blDataSelector = createSelector(commonSelector, (common) => common.blData);

export const entityDataSelector = createSelector(commonSelector, (common) => common.entityData);

export const entityInforDataSelector = createSelector(commonSelector, (common) => common.entityInforData);

export const containerTypeDataSelector = createSelector(commonSelector, (common) => common.containerType);

export const PODDataSelector = createSelector(commonSelector, (common) => common.PODData);

export const POLDataSelector = createSelector(commonSelector, (common) => common.POLData);

export const statusDataSelector = createSelector(commonSelector, (common) => common.statusData || []);

export const officeDataSelector = createSelector(commonSelector, (common) => common.officeData || []);

export const sqlTypeSelector = createSelector(commonSelector, (common) => common.sqlType);

export const isScrollBottomSelector = createSelector(commonSelector, (common) => common.isScrollBottom);

export const totalDataSelector = createSelector(commonSelector, (common) => common.total || 0);

export const loadSelector = createSelector(commonSelector, (common) => common.loading || false);

export const messageSelector = createSelector(commonSelector, (common) => common.message || '');

export const saleDeptDataSelector = createSelector(commonSelector, (common) => common.saleDeptData || []);

export const searchByDataSelector = createSelector(commonSelector, (common) => common.searchByData || []);

export const titleHeaderSelector = createSelector(commonSelector, (common) => common.titleHeader || '');

export const userInfoSelector = createSelector(commonSelector, (common) => common.userInfo || {});

export const dropListOfficeControlSelector = createSelector(commonSelector, (common) => common.dropListOfficeControl);

export const loadPolSelector = createSelector(commonSelector, (common) => common.loadingPolSelector || false);

export const loadPodSelector = createSelector(commonSelector, (common) => common.loadingPodSelector || false);

export const authorityDataSelector = createSelector(commonSelector, (common) => common.authorityData);

export const loginStatusDataSelector = createSelector(commonSelector, (common) => common.loginStatusData);

export const userTypeDataSelector = createSelector(commonSelector, (common) => common.userTypeData);

export const saleOfficeSelector = createSelector(commonSelector, (common) => common.saleOfficeData || []);

export const salePersonSelector = createSelector(commonSelector, (common) => common.salePersonData || []);

export const blRefTypeDataSelector = createSelector(commonSelector, (common) => common.blRefTypeData || []);

export const langTypeDataSelector = createSelector(commonSelector, (common) => common.langTypeData || []);

export const dateFormatInDataSelector = createSelector(commonSelector, (common) => common.dateFormatInData || []);

export const numFormatDataSelector = createSelector(commonSelector, (common) => common.numFormatData || []);

export const dateFormatDispDataSelector = createSelector(commonSelector, (common) => common.dateFormatDispData || []);

export const portTypeDataSelector = createSelector(commonSelector, (common) => common.portTypeData || []);

export const countryDataSelector = createSelector(commonSelector, (common) => common.countryData || []);

export const regionDataSelector = createSelector(commonSelector, (common) => common.regionData || []);

export const sqlConditionSelector = createSelector(commonSelector, (common) => common.sqlCondition || []);

export const isBackSelector = createSelector(commonSelector, (common) => common.isBack);

export const userGroupSelector = createSelector(commonSelector, (common) => common.userGroup || []);

export const getSignedUrlSelector = createSelector(commonSelector, (common) => common?.signedUrl);

export const statusModeDataSelector = createSelector(commonSelector, (common) => common.statusModeData || []);

export const inOutDataSelector = createSelector(commonSelector, (common) => common.inOutData || []);

export const custClearReqStatusDataSelector = createSelector(
  commonSelector,
  (common) => common.custClearReqStatusData || []
);

export const dlFlgDataSelector = createSelector(commonSelector, (common) => common.dlFlgData || []);

export const shippingFormDataSelector = createSelector(commonSelector, (common) => common.shippingFormData || []);

export const vehicleTypeDataSelector = createSelector(commonSelector, (common) => common.vehicleTypeData || []);

export const dayOfWeekDataSelector = createSelector(commonSelector, (common) => common.dayOfWeekData || []);

export const preTariffDataSelector = createSelector(commonSelector, (common) => common.preTariffData || []);

export const forwarderDataSelector = createSelector(commonSelector, (common) => common.forwarderData || []);

export const noticeTypeSelector = createSelector(commonSelector, (common) => common.noticeType);

export const readTypeSelector = createSelector(commonSelector, (common) => common.readType);

export const noticeItemHblBookingSelector = createSelector(commonSelector, (common) => common.noticeItemHblBooking);

export const noticeItemHblVesselMoveSelector = createSelector(
  commonSelector,
  (common) => common.noticeItemHblVesselMove
);

export const noticeItemCustSelector = createSelector(commonSelector, (common) => common.noticeItemCust);

export const noticeItemCustExportSelector = createSelector(commonSelector, (common) => common.noticeItemCustExport);

export const pdfDownloadSelector = createSelector(commonSelector, (common) => common?.pdfDownload);

export const chargeCdExportSelector = createSelector(commonSelector, (common) => common?.chargeCdExportData);

export const blTypeExportSelector = createSelector(commonSelector, (common) => common?.blTypeExportData);

export const tradeTypeSelector = createSelector(commonSelector, (common) => common.tradeType);

export const uploadFileMaxSizeCustSelector = createSelector(commonSelector, (common) => common.uploadFileMaxSizeCust);

export const deliveryFlgDataSelector = createSelector(commonSelector, (common) => common.deliveryFlgData);
